// extracted by mini-css-extract-plugin
export var heroCarousel = "heroCarousel-module--hero-carousel--6542e";
export var heroCarouselBg = "heroCarousel-module--hero-carousel-bg--70fde";
export var heroCarouselButtons = "heroCarousel-module--hero-carousel-buttons--02a45";
export var heroCarouselContent = "heroCarousel-module--hero-carousel-content--73ad9";
export var heroCarouselLeftcta = "heroCarousel-module--hero-carousel-leftcta--38c1e";
export var heroCarouselLeftctaText = "heroCarousel-module--hero-carousel-leftcta-text--7ac36";
export var heroCarouselRightcta = "heroCarousel-module--hero-carousel-rightcta--9b5ee";
export var heroCarouselRightctaText = "heroCarousel-module--hero-carousel-rightcta-text--baa1b";